import React from 'react'
import { renderToString } from 'react-dom/server'
import axios from '../../Axios'
import Button from '../Button'
import SummaryPageToEmail from '../../pages/SummaryPageToEmail'
import './EmailForm.css'

function devLog(...args) {
  if (process.env.NODE_ENV !== 'production') {
    console.log(...args)
  }
}

function valueOrEmpty(inputField) {
  return inputField ? inputField.value : ''
}

function checkedOrEmpty(inputField) {
  return inputField ? inputField.checked : ''
}

function checkFName(fName) {
  if (!fName.value) {
    fName.className = fName.className + ' invalid'
    return false
  } else {
    fName.className = fName.className
      .split(' ')
      .filter(s => s !== 'invalid')
      .join(' ')
    return true
  }
}

function checkLName(lName) {
  if (!lName.value) {
    lName.className = lName.className + ' invalid'
    return false
  } else {
    lName.className = lName.className
      .split(' ')
      .filter(s => s !== 'invalid')
      .join(' ')
    return true
  }
}

function checkEmail(email) {
  if (!/\S+@\S+\.\S+/.test(email.value)) {
    email.className = email.className + ' invalid'
    return false
  } else {
    email.className = email.className
      .split(' ')
      .filter(s => s !== 'invalid')
      .join(' ')
    return true
  }
}

function checkProvince(province) {
  if (!province.value) {
    province.className = province.className + ' invalid'
    return false
  } else {
    province.className = province.className
      .split(' ')
      .filter(s => s !== 'invalid')
      .join(' ')
    return true
  }
}

function checkCountry(country) {
  if (!country.value) {
    country.className = country.className + ' invalid'
    return false
  } else {
    country.className = country.className
      .split(' ')
      .filter(s => s !== 'invalid')
      .join(' ')
    return true
  }
}

function checkStoreData(agreeStoreData) {
  if (!agreeStoreData.checked) {
    const labelElement = document.getElementById('acceptStoreDataText')
    labelElement.className = labelElement.className + ' invalid-text'
    return false
  } else {
    const labelElement = document.getElementById('acceptStoreDataText')
    labelElement.className = labelElement.className
      .split(' ')
      .filter(s => s !== 'invalid-text')
      .join(' ')
    return true
  }
}

function checkAgreeOtherCommunication(agreeOtherCommunication) {
  if (!agreeOtherCommunication.checked) {
    const labelElement = document.getElementById('acceptOtherCommunicationText')
    labelElement.className = labelElement.className + ' invalid-text'
    return false
  } else {
    const labelElement = document.getElementById('acceptOtherCommunicationText')
    labelElement.className = labelElement.className
      .split(' ')
      .filter(s => s !== 'invalid-text')
      .join(' ')
    return true
  }
}

function formRequestReducer(state, action) {
  if (Object.keys(action).length > 0) {
    return {
      ...state,
      ...action,
    }
  }
  return state
}

function hasValidForm(e, data) {
  const {
    firstName,
    lastName,
    email,
    province,
    country,
    agreeOtherCommunication,
    agreeStoreData,
  } = e.target
  e.preventDefault()

  // Validate first name
  if (data.fieldsRequired.firstName && !checkFName(firstName)) {
    return false
  }

  // Validate last name
  if (data.fieldsRequired.lastName && !checkLName(lastName)) {
    return false
  }

  // Validate email
  if (data.fieldsRequired.email && !checkEmail(email)) {
    return false
  }

  // Validate country
  if (data.fieldsRequired.country && !checkCountry(country)) {
    return false
  }

  // make province required if:
  // 1. requiresCountries is not null
  // 2. requiresCountries value at the country selected is true
  // 3. province has a value
  // otherwise:
  // 1. check if the province field is required
  // 2. province has a value
  if (
    data.requiresCountries &&
    data.requiresCountries[country.value] &&
    !checkProvince(province)
  ) {
    return false
  } else if (data.fieldsRequired.province && !checkProvince(province)) {
    return false
  }

  if (
    data.fieldsRequired.agreeOtherCommunication &&
    !checkAgreeOtherCommunication(agreeOtherCommunication)
  ) {
    return false
  }

  if (data.fieldsRequired.agreeStoreData && !checkStoreData(agreeStoreData)) {
    return false
  }
  return true
}

function EmailForm({
  data = {},
  masked,
  onSubmitSuccess = () => {},
  wrapperState = {},
  summaryContent = {},
}) {
  const [country, setCountry] = React.useState('')
  const [countryIndex, setCountryIndex] = React.useState(0)
  const [agreeCommunication, setAgreeCommunication] = React.useState(false)
  const [agreeStoreData, setAgreeStoreData] = React.useState(false)
  const [formRequest, setFormRequest] = React.useReducer(formRequestReducer, {
    sent: false,
    error: false,
    loading: false,
  })
  const agreeCommunicationClassName = agreeCommunication
    ? 'legalText checkboxMessage checkboxMessageSelected'
    : 'legalText checkboxMessage'
  const agreeStoreDataClassName = agreeStoreData
    ? 'legalText checkboxMessage checkboxMessageSelected'
    : 'legalText checkboxMessage'

  async function submitQuizData(data) {
    const quizFormData = new FormData()
    Object.keys(data).forEach(dataKey => {
      quizFormData.append(dataKey, data[dataKey])
    })

    return await axios.post('/redirect.cfm', quizFormData)
  }

  async function handleFormSubmit(e) {
    e.preventDefault()
    const {
      firstName,
      lastName,
      email,
      province,
      country,
      agreeOtherCommunication,
      agreeStoreData,
    } = e.target

    const submission = {
      eid: '400_759B0E7B3A44E608A123D9EDE0628823',
      fid: '400_759B0E7B3A44E608A123D9EDE0628823',
      spam: '0',
      out: 'json',
      f400_759B0E7B3A44E608A123D9EDE0628823_act: 'submit',
      f400_759B0E7B3A44E608A123D9EDE0628823_first_name: valueOrEmpty(firstName),
      f400_759B0E7B3A44E608A123D9EDE0628823_last_name: valueOrEmpty(lastName),
      f400_759B0E7B3A44E608A123D9EDE0628823_email: valueOrEmpty(email),
      f400_759B0E7B3A44E608A123D9EDE0628823_country: valueOrEmpty(country),
      f400_759B0E7B3A44E608A123D9EDE0628823_region: valueOrEmpty(province),
      f400_759B0E7B3A44E608A123D9EDE0628823_acceptstore: checkedOrEmpty(
        agreeStoreData
      ),
      f400_759B0E7B3A44E608A123D9EDE0628823_acceptother: checkedOrEmpty(
        agreeOtherCommunication
      ),
      f400_759B0E7B3A44E608A123D9EDE0628823_emailbodytext: 'email text',
      f400_759B0E7B3A44E608A123D9EDE0628823_emailbodyhtml: renderToString(
        <SummaryPageToEmail
          data={summaryContent}
          firstName={valueOrEmpty(firstName)}
          wrapperState={wrapperState}
        />
      ),
    }
    if (hasValidForm(e, data)) {
      // cannot submit quiz in development due to CORS error
      if (process.env.NODE_ENV === 'production') {
        const { data } = await submitQuizData(submission)
        try {
          if (Object.keys(data.formerrors).length === 0) {
            setFormRequest({ error: false, sent: true })
            onSubmitSuccess()
          } else {
            setFormRequest({ error: true })
          }
        } catch {
          setFormRequest({ error: true })
        }
      } else {
        setFormRequest({ error: false, sent: true })
        onSubmitSuccess()
        devLog('Venus-Quiz: Email Submitted', submission)
      }
    } else {
      devLog('Venus-Quiz: Failed to submit', submission)
    }
  }

  const regions = data.regions[countryIndex].split('|')
  let statesTitle = country
    ? data.countries.find(coun => {
        if (typeof coun === 'string') {
          return false
        }
        return coun.name === country
      })
    : undefined
  if (typeof statesTitle === 'object') {
    statesTitle = statesTitle.states
  } else {
    statesTitle = undefined
  }

  return (
    <div className="emailWrapper">
      {masked < 1 && <div className="emailFormMask" />}
      <form onSubmit={handleFormSubmit} className="emailForm">
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <div className="half input">
            <p className="inputLabel">
              {data.fName}
              <span className="requiredStar">
                {data.fieldsRequired.firstName && '*'}
              </span>
            </p>
            <input type="text" name="firstName" />
          </div>
          <div className="half input">
            <p className="inputLabel">
              {data.lName}
              <span className="requiredStar">
                {data.fieldsRequired.lastName && '*'}
              </span>
            </p>
            <input type="text" name="lastName" />
          </div>
        </div>
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
        >
          <div className="third input">
            <p className="inputLabel">
              {data.email}
              <span className="requiredStar">
                {data.fieldsRequired.email && '*'}
              </span>
            </p>
            <input type="text" name="email" />
          </div>
          <div className="third input">
            <p className="inputLabel">
              {data.countryText}
              <span className="requiredStar">
                {(data.fieldsRequired.countries ||
                  data.requiresCountries[country]) &&
                  '*'}
              </span>
            </p>
            <select
              name="country"
              defaultValue={country}
              onChange={e => {
                setCountry(e.target.value)
                setCountryIndex(e.target.selectedIndex)
              }}
            >
              <option value="" disabled>
                {`${data.selectText}${data.countryText}`}
              </option>
              {data.countries.map((s, i) => {
                return typeof s === 'string' ? (
                  <option id={i} value={s} key={i}>
                    {s}
                  </option>
                ) : (
                  <option id={i} value={s.name} key={i}>
                    {s.name}
                  </option>
                )
              })}
            </select>
          </div>
          <div className="third input">
            {data.requiresCountries[country] && (
              <React.Fragment>
                <p className="inputLabel">
                  {statesTitle}
                  <span className="requiredStar">
                    {(data.fieldsRequired.province ||
                      data.requiresCountries[country]) &&
                      '*'}
                  </span>
                </p>
                <select name="province" defaultValue="">
                  <option value="" disabled>
                    {`${data.selectText}${statesTitle}`}
                  </option>
                  {regions.map((s, i) => (
                    <option value={s} key={i}>
                      {s}
                    </option>
                  ))}
                </select>
              </React.Fragment>
            )}
          </div>
        </div>
        <div className="consent-form">
          <p className="legalText">{data.legal1}</p>
          <div style={{ display: 'flex' }}>
            <input
              type="checkbox"
              name="agreeOtherCommunication"
              checked={agreeCommunication}
              onChange={() => setAgreeCommunication(!agreeCommunication)}
            />
            <label
              htmlFor="agreeOtherCommunication"
              id="acceptOtherCommunicationText"
              className={agreeCommunicationClassName}
              onClick={() => setAgreeCommunication(!agreeCommunication)}
            >
              <span className="checkboxLabel">
                {data.acceptTextOtherCommunication}
              </span>
              <span className="requiredStar">
                {data.fieldsRequired.agreeOtherCommunication && '*'}
              </span>
            </label>
          </div>
          <p className="legalText">{data.legal2}</p>
          <div style={{ display: 'flex' }}>
            <input
              type="checkbox"
              name="agreeStoreData"
              checked={agreeStoreData}
              onChange={() => setAgreeStoreData(!agreeStoreData)}
            />
            <label
              htmlFor="agreeStoreData"
              id="acceptStoreDataText"
              className={agreeStoreDataClassName}
              onClick={() => setAgreeStoreData(!agreeStoreData)}
            >
              <span className="checkboxLabel">{data.acceptTextStoreData}</span>
              <span className="requiredStar">
                {data.fieldsRequired.agreeStoreData && '*'}
              </span>
            </label>
          </div>
          <p className="legalText">{data.legal3}</p>
          <p className="legalButton">
            <Button
              variant="blue"
              shape="round"
              action="submit"
              disabled={formRequest.sent && !formRequest.error}
            >
              {data.submit}
            </Button>
          </p>
        </div>
      </form>
    </div>
  )
}

export default EmailForm
